import {theme} from "../../../../utils";

export type CardItem = {
    title: string;
    card_description: string;
    description: string;
};

export type CardProps = {
    item: CardItem;
    logoImage: any;
    index: number;
    onSelectVendorItem: (item: CardItem) => void;
};

export const vendorCardStyles = {
    container: {
        height: "236px",
        width: "524px",
        border: '.89px solid #CDCDCD',
        borderRadius: "8px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        margin: "20px",
        paddingTop: "10px",
        backgroundColor: "#F8F8F8"
    },
    imagePanel: {
        padding: "10px",
        width: "180px",
    },
    contentPanel: {
        marginTop: "15px",
        padding: "10px",
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        marginBottom: "10px",
    },
    cardTitle: {
        ...theme.typography.poppinsBodySemiBold,
        fontSize: "24px",
        color: "#1E1E22",
        textAlign: "left"
    },
    cardActionPanel: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
        justifyContent: 'start',
        width: '100%'
    },
    cardDescription: {
        ...theme.typography.poppinsBodyLight,
        py: "8px",
        maxWidth: "678px",
        color: "#2D2B2A",
        fontSize: "20px",
        lineHeight: "130%",
        textAlign: "left"
    },
    cardButton: {
        border: ".89px solid #404144",
        borderRadius: "8px",
        width: "128px",
        height: "39px",
        gap: "10px",
        px: "15px"
    },
    cardButtonText: {
        ...theme.typography.components.montseratButtonOutlinedLabel,
        color: "#404144",
        textTransform: "none",
        fontSize: "13.96px",
        letterSpacing: "-1.5px",
        lineHeight: "100%",
    },
}